import { HttpClient } from '@angular/common/http'
import { APP_INITIALIZER, Injectable, Renderer2, RendererFactory2 } from '@angular/core'
import { DomSanitizer } from '@angular/platform-browser'
import {
    OccEndpointsService,
    WindowRef
} from '@spartacus/core'
import { default as googleAnalyticsScript } from 'src/assets/analytics/google-analytics-script'
import { GoogleAnalytics } from '../organization/uig-user/uig-user.model'

@Injectable({ providedIn: 'root' })
export class UigAnalyticsService {

    gtagUrl = 'https://www.googletagmanager.com/gtag/js?id='

    constructor(
        protected rendererFactory: RendererFactory2,
        protected winRef: WindowRef,
        protected occEndpoints: OccEndpointsService,
        protected http: HttpClient,
        protected sanitizer: DomSanitizer
    ) { }

    static get initializeProvider() {
        return {
            provide: APP_INITIALIZER,
            useFactory: UigAnalyticsService.setupGoogleAnalytics,
            multi: true,
            deps: [UigAnalyticsService]
        }
    }

    private static setupGoogleAnalytics(
        uigAnalyticsService: UigAnalyticsService,
    ) {
        return () => {
            uigAnalyticsService.addGoogleAnalyticsScript();
        }
    }

    private get renderer(): Renderer2 {
        return this.rendererFactory.createRenderer(null, null);
    }

    addGoogleAnalyticsScript() {
        return this.http.get<GoogleAnalytics>(
            this.occEndpoints.buildUrl('googleAnalyticsID')
        ).subscribe((googleAnalytics) => {
            if(googleAnalytics.id) {
                const asyncScript = this.renderer.createElement('script');
                asyncScript.src = this.gtagUrl + googleAnalytics.id;
                this.renderer.appendChild(this.winRef.document.head, asyncScript);

                const analyticsScript = this.renderer.createElement('script');
                analyticsScript.text = googleAnalyticsScript.replace('{$SITE-ID}', "'" + googleAnalytics.id + "'");
                this.renderer.appendChild(this.winRef.document.head, analyticsScript);
            }
        });
    }
}
